import {gsap} from 'gsap'
import {ScrollSmoother} from 'gsap/ScrollSmoother'
import {ScrollTrigger} from 'gsap/ScrollTrigger'


gsap.registerPlugin(ScrollSmoother);
gsap.registerPlugin(ScrollTrigger);

let smoothScroll

let smoothScrollEffects = true
if (window.innerWidth < 1200) smoothScrollEffects = false
const $mainMenu = $('.main-menu')

let smoothScrollParams = {
  smooth: 1.5,   // seconds it takes to "catch up" to native scroll position
  smoothTouch: 0.5, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
  effects: $(window).width() >= 1024,
  onUpdate: (scroll) => {

    if (!scroll.scrollTrigger) return false
    if (scroll.scrollTrigger.progress > 0.01) {
      if (scroll.scrollTrigger.direction === 1) {
        $mainMenu.addClass('is-hidden')
      } else {
        $mainMenu.removeClass('is-hidden')
      }
    }
  }
}

function createSmoothScroll() {
  if (smoothScroll) {
    smoothScroll.kill();
  }
  smoothScroll = ScrollSmoother.create(smoothScrollParams);
}

if (typeof ScrollSmoother === 'function') {
  createSmoothScroll();
}

export function scrollToId(element) {
  smoothScroll.scrollTo(element, true)
}

export function getSmoothScroll() {
  return smoothScroll
}

export function smoothScrollPause() {
  smoothScroll.paused(true)
}

export function smoothScrollPlay() {
  smoothScroll.paused(false)
}

export function updateSmoothScroll() {
  ScrollTrigger.refresh()
}

export function smoothScrollKill() {
  smoothScroll.kill()
}

export function smoothScrollCreate() {
  smoothScroll = ScrollSmoother.create(smoothScrollParams);
}

let lastWindowWidth = $(window).width();

$(window).resize(() => {
  let newWindowWidth = $(window).width();
  let wasAboveBreakpoint = lastWindowWidth >= 1024;
  let isAboveBreakpoint = newWindowWidth >= 1024;

  if (wasAboveBreakpoint !== isAboveBreakpoint) {
    smoothScrollParams.effects = isAboveBreakpoint;
    createSmoothScroll();
  }

  lastWindowWidth = newWindowWidth;
});
